import { STATIC_ACCESS_TOKEN } from '@/config/settings'
import type { Auth } from './type'

export function getPublicAuth(): Auth {
  return STATIC_ACCESS_TOKEN
}
